import React, { FC } from 'react'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface ReliabilityWebsiteSupportProps {
    websiteSupportData: any
}

const ReliabilityWebsiteSupport: FC<ReliabilityWebsiteSupportProps> = ({ websiteSupportData }) => {
    return (
        <div>
            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-16 p-6 sm:p-10 md:p-16 lg:p-20 pt-10 md:pt-16 px-4 sm:px-8 md:px-16 lg:px-36'>
                {websiteSupportData.ReliabilityWebSupportData.map((reliable: any, index: number) => {
                    let img = getImage(reliable.image ?? "") ?? "";
                    return (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{
                                duration: 0.5,
                                ease: "easeOut",
                                delay: 0.1 + (index * 0.1) // staggered delay based on index
                            }}

                        >
                            <motion.div className='relative p-[1px] flex rounded-3xl bg-blackDark'
                                whileHover={{
                                    backgroundImage: `linear-gradient(354.61deg, ${reliable.bgColor} -38.83%, rgba(255, 185, 18, 0) 91.93%)`,
                                    scale: 1.03,
                                    transition: { duration: 0.3 }
                                }}>
                                <motion.div
                                    className='bg-blackDark p-4 sm:p-6 md:p-8 rounded-3xl flex items-center gap-3 sm:gap-4 md:gap-6 w-full'

                                >
                                    <motion.div
                                        className='p-[1px] rounded-full flex items-center justify-center bg-darkGreyPrimary'
                                        whileHover={{
                                            backgroundImage: `linear-gradient(354.61deg, ${reliable.bgColor} -38.83%, rgba(255, 185, 18, 0) 91.93%)`
                                        }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <motion.div
                                            className='p-6 rounded-full flex items-center justify-center bg-darkGreyPrimary'
                                            whileHover={{
                                                rotate: [0, -5, 5, -5, 0],
                                            }}
                                            transition={{ duration: 0.5 }}
                                        >
                                            <div className='flex items-center justify-center text-black font-black text-xl w-8'>
                                                {/* <img src={reliable.image} className='w-12' /> */}
                                                <DynamicSVG size='w-12'>{img}</DynamicSVG>
                                            </div>
                                        </motion.div>
                                    </motion.div>

                                    <div className='flex flex-col gap-1'>
                                        <span className={`text-base sm:text-lg md:text-xl font-medium text-white`}>
                                            <b>{reliable.title}</b>
                                        </span>
                                        <span className='text-sm sm:text-base text-[#E0E0E0]'>
                                            {reliable.subtitle}
                                        </span>
                                    </div>
                                </motion.div>
                            </motion.div>
                        </motion.div>
                    )
                })}
            </div>
        </div >
    )
}

export default ReliabilityWebsiteSupport
